import { getDateOrdinal } from '../../../../utils/date';
import * as errorMessage from '../../../../constants/ErrorMessages';
import { InvestFrequency } from '../../../../pages/transact/invest';

interface nomineesDetails {
  nomineeDetails: {
    name: string;
    dateOfBirth: any;
    relationShip: string;
    relationshipCode: string;
    address: string;
    documentType: string;
    documentNumber: string;
    city: string;
    pinCode: string;
    phone: string;
    email: string;
    country: string;
    nreFlag: string;
  };
  share: number;
  guardian: {
    name: string;
    dateOfBirth: any;
    relationShip: string;
    relationshipCode: string;
    address: string;
    documentType: string;
    documentNumber: string;
    city: string;
    pinCode: string;
    phone: string;
    email: string;
    country: string;
    nreFlag: string;
  };
}

interface nomineeValidateDetails {
  nomineeDetails: {
    name: string;
    dateOfBirth: any;
    relationShip: string;
    relationshipCode: string;
    address: string;
    documentType: string;
    documentNumber: string;
    city: string;
    pinCode: string;
    phone: string;
    email: string;
    country: string;
    nreFlag: string;
  };
  share: number;
  investmentId: string;
  tranType: string;
  guardian: {
    name: string;
    dateOfBirth: any;
    relationShip: string;
    relationshipCode: string;
    address: string;
    documentType: string;
    documentNumber: string;
    city: string;
    pinCode: string;
    phone: string;
    email: string;
    country: string;
    nreFlag: string;
  };
}

export const formatValueForDropDown = (value: string) => {
  return { label: value, value: value };
};

export const convertArrayOfStringsToDropDownOptionsFormat = (
  arrayOfValues: Array<any>,
  suffix?: boolean,
  suffixText?: string | null
) => {
  const options = [];
  arrayOfValues &&
    arrayOfValues?.map((value, index) => {
      options?.push({ label: `${suffix ? getDateOrdinal(value) + suffixText : value}`, value: value });
    });
  return options;
};

export const formatToEvent = (fieldName: string, value: any) => {
  const event = {
    target: {
      label: fieldName,
      value: value,
      id: fieldName,
    },
  };
  return event;
};

export const getSipFrequencyOptions = (sipFrequency: Array<InvestFrequency>) => {
  const options = [];
  sipFrequency &&
    sipFrequency?.map((value, index) => {
      const frequency = value?.displayName;
      options?.push({ label: frequency, value: frequency });
    });
  return options;
};

export const getMinimumSipAmount = (frequencySelected: string, sipFrequency: Array<InvestFrequency>) => {
  return sipFrequency?.filter((sip) => sip?.displayName === frequencySelected)[0]?.minSipAmount;
};

export const getPreferredDates = (frequencySelected: string, sipFrequency: Array<InvestFrequency>) => {
  return sipFrequency?.filter((sip) => sip?.displayName === frequencySelected)[0]?.preferredDates;
};

export const convertArrayOfStringsToDropDownOptionsFormatWithSecondaryLabel = (
  arrayOfValues: Array<any>,
  primaryLabelName: string,
  secondaryLabelName: string
) => {
  const options = [];
  arrayOfValues &&
    arrayOfValues.map((value: any, index) => {
      let labelString = value[secondaryLabelName];
      if (value.mode_of_oper_ac === 'AS') {
        let firstName =
          value.name.split(' ')[0].length > 10 ? value.name.split(' ')[0].slice(0, 3) : value.name.split(' ')[0];

        if (value.second_Holder_Name?.length) {
          let secondName =
            value.second_Holder_Name.split(' ')[0].length > 10
              ? value.second_Holder_Name.split(' ')[0].slice(0, 3)
              : value.second_Holder_Name.split(' ')[0];
          labelString = firstName + '/ ' + secondName;
        }

        if (value?.third_Holder_Name?.length) {
          let thirdName =
            value.third_Holder_Name.split(' ')[0].length > 10
              ? value.third_Holder_Name.split(' ')[0].slice(0, 3)
              : value.third_Holder_Name.split(' ')[0];
          labelString = labelString + '/ ' + thirdName;
        }
      }

      options.push({
        label: value[primaryLabelName],
        value: value[primaryLabelName],
        secondaryLabelName: labelString,
      });
    });
  return options;
};

export const whetherMFTransactionAllowedForSelectedInvestmentId = (
  investmentIdsObject: object,
  selectedInvestmentId: string
) => {
  if (
    investmentIdsObject[selectedInvestmentId]?.whetherMFTransactionAllowed === 'Y' &&
    investmentIdsObject[selectedInvestmentId]?.investmentAccountMismatch === 'N'
  ) {
    return true;
  }
  return false;
};

export const convertToNomineesDataFormat = (
  arrayOfNomineeDetails: Array<nomineesDetails>,
  relationShipCodeObject: object
) => {
  let nominees = [];
  arrayOfNomineeDetails &&
    arrayOfNomineeDetails.map((details, index) => {
      nominees.push({
        name: details.nomineeDetails?.name,
        share: details.share,
        relationshipCode: relationShipCodeObject[details.nomineeDetails?.relationShip].code,
        dob: details.nomineeDetails?.dateOfBirth,
        address: details.nomineeDetails?.address,
        documentType: details.nomineeDetails?.documentType,
        documentNumber: details.nomineeDetails?.documentNumber,
        city: details.nomineeDetails?.city,
        pinCode: details.nomineeDetails?.pinCode,
        phone: details.nomineeDetails?.phone,
        email: details.nomineeDetails?.email,
        country: details.nomineeDetails?.country,
        nreFlag: details.nomineeDetails?.nreFlag,
        guardianName: details.guardian?.name === undefined ? '' : details.guardian?.name,
      });
    });
  return nominees;
};

export const convertToDefaultNomineeDataFormat = (
  arrayOfNomineeDetails: Array<nomineesDetails>,
  relationShipCodeObject: object,
  nomSOA: boolean
) => {
  let nominees = [];
  arrayOfNomineeDetails &&
    arrayOfNomineeDetails.map((details, index) => {
      nominees.push({
        nomineeDetails: {
          name: details?.nomineeDetails?.name,
          dateOfBirth: details?.nomineeDetails?.dateOfBirth,
          relationShip: details?.nomineeDetails?.relationShip,
          relationshipCode: relationShipCodeObject[details.nomineeDetails?.relationShip.toUpperCase()].code,
          address: details.nomineeDetails?.address,
          documentType: details.nomineeDetails?.documentType,
          documentNumber: details.nomineeDetails?.documentNumber?.toUpperCase(),
          city: details.nomineeDetails?.city,
          pinCode: details.nomineeDetails?.pinCode,
          phone: details.nomineeDetails?.phone,
          email: details.nomineeDetails?.email,
          country: details.nomineeDetails?.country,
          nreFlag: details.nomineeDetails?.nreFlag,
        },
        share: details?.share,
        nomSOA: nomSOA ? 'Y' : 'N',
        guardian: {
          name: details?.guardian?.name,
          dateOfBirth: details?.guardian?.dateOfBirth,
          relationShip: details?.guardian?.relationShip,
          address: details?.guardian?.address,
          documentType: details?.guardian?.documentType,
          documentNumber: details?.guardian?.documentNumber,
          city: details?.guardian?.city,
          pinCode: details?.guardian?.pinCode,
          phone: details?.guardian?.phone,
          email: details?.guardian?.email,
          country: details?.guardian?.country,
          nreFlag: details?.guardian?.nreFlag,
        },
      });
    });
  return nominees;
};

export const convertToDefaultNomineeUIFormat = (arrayOfNomineeDetails: Array<nomineesDetails>) => {
  let nominees = [];
  arrayOfNomineeDetails &&
    arrayOfNomineeDetails.map((details, index) => {
      nominees.push({
        nomineeDetails: {
          name: details?.nomineeDetails?.name,
          dateOfBirth: details?.nomineeDetails?.dateOfBirth,
          relationShip: details?.nomineeDetails?.relationShip,
          address: details.nomineeDetails?.address,
          documentType: details.nomineeDetails?.documentType,
          documentNumber: details.nomineeDetails?.documentNumber,
          city: details.nomineeDetails?.city,
          pinCode: details.nomineeDetails?.pinCode,
          phone: details.nomineeDetails?.phone,
          email: details.nomineeDetails?.email,
          country: details.nomineeDetails?.country,
          nreFlag: details.nomineeDetails?.nreFlag,
        },
        share: details?.share,
        guardian: details?.guardian
          ? {
              name: details?.guardian?.name,
              dateOfBirth: details?.guardian?.dateOfBirth,
              relationShip: details?.guardian?.relationShip,
              address: details?.guardian?.address,
              documentType: details?.guardian?.documentType,
              documentNumber: details?.guardian?.documentNumber,
              city: details?.guardian?.city,
              pinCode: details?.guardian?.pinCode,
              phone: details?.guardian?.phone,
              email: details?.guardian?.email,
              country: details?.guardian?.country,
              nreFlag: details?.guardian?.nreFlag,
            }
          : {},
      });
    });
  return nominees;
};

export const getRelationshipDropdownDetails = (isNominee) => {
  const options = [];
  isNominee
    ? options.push(
        { label: 'Father', value: 'Father' },
        { label: 'Mother', value: 'Mother' },
        { label: 'Husband', value: 'Husband' },
        { label: 'Wife', value: 'Wife' },
        { label: 'Son', value: 'Son' },
        { label: 'Daughter', value: 'Daughter' },
        { label: 'Brother', value: 'Brother' },
        { label: 'Sister', value: 'Sister' },
        { label: 'Grand Father', value: 'Grand Father' },
        { label: 'Grand Mother', value: 'Grand Mother' },
        { label: 'Uncle', value: 'Uncle' },
        { label: 'Aunt', value: 'Aunt' },
        { label: 'Nephew', value: 'Nephew' },
        { label: 'Niece', value: 'Niece' },
        { label: 'Grand Son', value: 'Grand Son' },
        { label: 'Grand Daughter', value: 'Grand Daughter' },
        { label: 'Partner', value: 'Partner' },
        { label: 'Power of Attorney Holder', value: 'Power of Attorney Holder' },
        { label: 'Guarantor', value: 'Guarantor' },
        { label: 'Karta', value: 'Karta' },
        { label: 'Co-Parcener', value: 'Co-Parcener' },
        { label: 'Minor Co-Parcener', value: 'Minor Co-Parcener' },
        { label: 'Beneficial Owner', value: 'Beneficial Owner' }
      )
    : options.push(
        { label: 'Court Appointed Legal Guardian', value: 'Court Appointed Legal Guardian' },
        { label: 'Father', value: 'Father' },
        { label: 'Mother', value: 'Mother' }
      );
  return options;
};

export const getDocumentDropdownDetails = (nreFlag) => {
  const options = [];
  nreFlag === 'Y'
    ? options.push(
        { label: 'PAN', value: 'PAN' },
        { label: 'AADHAAR', value: 'AADHAAR' },
        { label: 'Driving License', value: 'Driving License' },
        { label: 'Passport', value: 'Passport' }
      )
    : options.push(
        { label: 'PAN', value: 'PAN' },
        { label: 'AADHAAR', value: 'AADHAAR' },
        { label: 'Driving License', value: 'Driving License' }
      );
  return options;
};

export const getCountryDropdownDetails = () => {
  const options = [];
  options.push(
    { value: 'India', label: 'India' },
    { value: 'Afghanistan', label: 'Afghanistan' },
    { value: 'Aland Islands', label: 'Aland Islands' },
    { value: 'Algeria', label: 'Algeria' },
    { value: 'Andorra', label: 'Andorra' },
    { value: 'Angola', label: 'Angola' },
    { value: 'Anguilla', label: 'Anguilla' },
    { value: 'Antarctica', label: 'Antarctica' },
    { value: 'Antigua And Barbuda', label: 'Antigua And Barbuda' },
    { value: 'Argentina', label: 'Argentina' },
    { value: 'Armenia', label: 'Armenia' },
    { value: 'Aruba', label: 'Aruba' },
    { value: 'Australia', label: 'Australia' },
    { value: 'Austria', label: 'Austria' },
    { value: 'Azerbaijan', label: 'Azerbaijan' },
    { value: 'Bahamas', label: 'Bahamas' },
    { value: 'Bahrain', label: 'Bahrain' },
    { value: 'Bangladesh', label: 'Bangladesh' },
    { value: 'Barbados', label: 'Barbados' },
    { value: 'Belarus', label: 'Belarus' },
    { value: 'Belgium', label: 'Belgium' },
    { value: 'Benin', label: 'Benin' },
    { value: 'Bermuda', label: 'Bermuda' },
    { value: 'Bhutan', label: 'Bhutan' },
    { value: 'Bonaire, Sint Eustatius And Saba', label: 'Bonaire, Sint Eustatius And Saba' },
    { value: 'Botswana', label: 'Botswana' },
    { value: 'Bouvet Island', label: 'Bouvet Island' },
    { value: 'Brazil', label: 'Brazil' },
    { value: 'British Indian Ocean Territory', label: 'British Indian Ocean Territory' },
    { value: 'Bulgaria', label: 'Bulgaria' },
    { value: 'Burkina Faso', label: 'Burkina Faso' },
    { value: 'Burundi', label: 'Burundi' },
    { value: 'CZECH REPUBLIC', label: 'CZECH REPUBLIC' },
    { value: 'Camaroon', label: 'Camaroon' },
    { value: 'Cambodia', label: 'Cambodia' },
    // { "value": "CA", "title": "Canada" },
    { value: 'Cape Verde', label: 'Cape Verde' },
    { value: 'Cayman Islands', label: 'Cayman Islands' },
    { value: 'Central African Republic', label: 'Central African Republic' },
    { value: 'Chad', label: 'Chad' },
    { value: 'China', label: 'China' },
    { value: 'Christmas Island', label: 'Christmas Island' },
    { value: 'Cocos (Keeling) Islands', label: 'Cocos (Keeling) Islands' },
    { value: 'Colombia', label: 'Colombia' },
    { value: 'Comoros', label: 'Comoros' },
    { value: 'Congo', label: 'Congo' },
    { value: 'Congo, The Democratic Republic Of The', label: 'Congo, The Democratic Republic Of The' },
    { value: 'Cook Islands', label: 'Cook Islands' },
    { value: 'Croatia', label: 'Croatia' },
    { value: 'Cuba', label: 'Cuba' },
    { value: 'Curacao', label: 'Curacao' },
    { value: 'Cyprus', label: 'Cyprus' },
    { value: 'Denmark', label: 'Denmark' },
    { value: 'Djibouti', label: 'Djibouti' },
    { value: 'Dominica', label: 'Dominica' },
    { value: 'Dominican Republic', label: 'Dominican Republic' },
    { value: 'El Salvador', label: 'El Salvador' },
    { value: 'Equador', label: 'Equador' },
    { value: 'Equatorial Guinea', label: 'Equatorial Guinea' },
    { value: 'Eritrea', label: 'Eritrea' },
    { value: 'Estonia', label: 'Estonia' },
    { value: 'Ethiopia', label: 'Ethiopia' },
    { value: 'Eygpt', label: 'Eygpt' },
    { value: 'Falkland Islands (Malvinas)', label: 'Falkland Islands (Malvinas)' },
    { value: 'Faroe Islands', label: 'Faroe Islands' },
    { value: 'Fiji', label: 'Fiji' },
    { value: 'Finland', label: 'Finland' },
    { value: 'France', label: 'France' },
    { value: 'French Guiana', label: 'French Guiana' },
    { value: 'French Polynesia', label: 'French Polynesia' },
    { value: 'French Southern Territories', label: 'French Southern Territories' },
    { value: 'Gabon', label: 'Gabon' },
    { value: 'Gambia', label: 'Gambia' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Germany', label: 'Germany' },
    { value: 'Ghana', label: 'Ghana' },
    { value: 'Gibraltar', label: 'Gibraltar' },
    { value: 'Greece', label: 'Greece' },
    { value: 'Greenland', label: 'Greenland' },
    { value: 'Grenada', label: 'Grenada' },
    { value: 'Guadeloupe', label: 'Guadeloupe' },
    { value: 'Guam', label: 'Guam' },
    { value: 'Guatemala', label: 'Guatemala' },
    { value: 'Guernsey', label: 'Guernsey' },
    { value: 'Guinea', label: 'Guinea' },
    { value: 'Guinea-Bissau', label: 'Guinea-Bissau' },
    { value: 'Guyana', label: 'Guyana' },
    { value: 'Haiti', label: 'Haiti' },
    { value: 'Heard Island And McDonald Islands', label: 'Heard Island And McDonald Islands' },
    { value: 'Honduras', label: 'Honduras' },
    { value: 'Hong Kong', label: 'Hong Kong' },
    { value: 'Hungary', label: 'Hungary' },
    { value: 'Indonesia', label: 'Indonesia' },
    { value: 'Iran', label: 'Iran' },
    { value: 'Iraq', label: 'Iraq' },
    { value: 'Ireland', label: 'Ireland' },
    { value: 'Isle Of Man', label: 'Isle Of Man' },
    { value: 'Israel', label: 'Israel' },
    { value: 'Italy', label: 'Italy' },
    { value: 'Jamaica', label: 'Jamaica' },
    { value: 'Japan', label: 'Japan' },
    { value: 'Jersey', label: 'Jersey' },
    { value: 'Jordan', label: 'Jordan' },
    { value: 'Kenya', label: 'Kenya' },
    { value: 'Kiribati', label: 'Kiribati' },
    { value: 'Kuwait', label: 'Kuwait' },
    { value: 'Kyrgyzstan', label: 'Kyrgyzstan' },
    { value: 'Lao People Democratic Republic', label: "Lao People's Democratic Republic" },
    { value: 'Latvia', label: 'Latvia' },
    { value: 'Lebanon', label: 'Lebanon' },
    { value: 'Lesotho', label: 'Lesotho' },
    { value: 'Liberia', label: 'Liberia' },
    { value: 'Libyan Arab Jamahiriya', label: 'Libyan Arab Jamahiriya' },
    { value: 'Liechtenstein', label: 'Liechtenstein' },
    { value: 'Lithuania', label: 'Lithuania' },
    { value: 'Luxembourg', label: 'Luxembourg' },
    { value: 'Macedonia, The Former Yugoslav Republic Of', label: 'Macedonia, The Former Yugoslav Republic Of' },
    { value: 'Madagascar', label: 'Madagascar' },
    { value: 'Malawi', label: 'Malawi' },
    { value: 'Malaysia', label: 'Malaysia' },
    { value: 'Maldives', label: 'Maldives' },
    { value: 'Mali', label: 'Mali' },
    { value: 'Malta', label: 'Malta' },
    { value: 'Marshall Islands', label: 'Marshall Islands' },
    { value: 'Martinique', label: 'Martinique' },
    { value: 'Mauritania', label: 'Mauritania' },
    { value: 'Mauritius', label: 'Mauritius' },
    { value: 'Mayotte', label: 'Mayotte' },
    { value: 'Mexico', label: 'Mexico' },
    { value: 'Micronesia, Federated States Of', label: 'Micronesia, Federated States Of' },
    { value: 'Monaco', label: 'Monaco' },
    { value: 'Mongolia', label: 'Mongolia' },
    { value: 'Montenegro', label: 'Montenegro' },
    { value: 'Montserrat', label: 'Montserrat' },
    { value: 'Mozambique', label: 'Mozambique' },
    { value: 'Myanmar', label: 'Myanmar' },
    { value: 'Namibia', label: 'Namibia' },
    { value: 'Nauru', label: 'Nauru' },
    { value: 'Nepal', label: 'Nepal' },
    { value: 'Netherlands', label: 'Netherlands' },
    { value: 'Netherlands Antilles', label: 'Netherlands Antilles' },
    { value: 'New Caledonia', label: 'New Caledonia' },
    { value: 'New Zealand', label: 'New Zealand' },
    { value: 'Nicaragua', label: 'Nicaragua' },
    { value: 'Nigeria', label: 'Nigeria' },
    { value: 'Niue', label: 'Niue' },
    { value: 'Norfolk Island', label: 'Norfolk Island' },
    { value: 'Northern Mariana Islands', label: 'Northern Mariana Islands' },
    { value: 'Norway', label: 'Norway' },
    { value: 'Not categorised', label: 'Not categorised' },
    { value: 'Oman', label: 'Oman' },
    { value: 'Other', label: 'Other' },
    { value: 'Pakistan', label: 'Pakistan' },
    { value: 'Palau', label: 'Palau' },
    { value: 'Palestine', label: 'Palestine' },
    { value: 'Papua New Guinea', label: 'Papua New Guinea' },
    { value: 'Paraguay', label: 'Paraguay' },
    { value: 'Peru', label: 'Peru' },
    { value: 'Philippines', label: 'Philippines' },
    { value: 'Portugal', label: 'Portugal' },
    { value: 'Qatar', label: 'Qatar' },
    { value: 'Reunion Island', label: 'Reunion Island' },
    { value: 'Romania', label: 'Romania' },
    { value: 'Russia', label: 'Russia' },
    { value: 'Rwanda', label: 'Rwanda' },
    { value: 'Saint Helena, Ascension And Tristan da Cunha', label: 'Saint Helena, Ascension And Tristan da Cunha' },
    { value: 'Saint Kitts And Nevis', label: 'Saint Kitts And Nevis' },
    { value: 'Saint Lucia', label: 'Saint Lucia' },
    { value: 'Saint Martin', label: 'Saint Martin' },
    { value: 'Saint Pierre And Miquelon', label: 'Saint Pierre And Miquelon' },
    { value: 'Saint Vincent And The Grenadines', label: 'Saint Vincent And The Grenadines' },
    { value: 'Samoa', label: 'Samoa' },
    { value: 'San Marino', label: 'San Marino' },
    { value: 'Sao Tome And Principe', label: 'Sao Tome And Principe' },
    { value: 'Saudi Arabia', label: 'Saudi Arabia' },
    { value: 'Senegal', label: 'Senegal' },
    { value: 'Seychelles', label: 'Seychelles' },
    { value: 'Singapore', label: 'Singapore' },
    { value: 'Sint Maarten (Dutch Part)', label: 'Sint Maarten (Dutch Part)' },
    { value: 'Solomon Islands', label: 'Solomon Islands' },
    { value: 'Somalia', label: 'Somalia' },
    { value: 'South Africa', label: 'South Africa' },
    { value: 'South Georgia And The South Sandwich Islands', label: 'South Georgia And The South Sandwich Islands' },
    { value: 'South Korea', label: 'South Korea' },
    { value: 'South Sudan', label: 'South Sudan' },
    { value: 'Spain', label: 'Spain' },
    { value: 'SriLanka', label: 'SriLanka' },
    { value: 'Svalbard And Jan Mayen Islands', label: 'Svalbard And Jan Mayen Islands' },
    { value: 'Swaziland', label: 'Swaziland' },
    { value: 'Sweden', label: 'Sweden' },
    { value: 'Switzerland', label: 'Switzerland' },
    { value: 'Syria', label: 'Syria' },
    { value: 'Tajikistan', label: 'Tajikistan' },
    { value: 'Tanzania', label: 'Tanzania' },
    { value: 'Thailand', label: 'Thailand' },
    { value: 'Timor-Leste', label: 'Timor-Leste' },
    { value: 'Togo', label: 'Togo' },
    { value: 'Tonga', label: 'Tonga' },
    { value: 'Trinidad And Tobago', label: 'Trinidad And Tobago' },
    { value: 'Tunisia', label: 'Tunisia' },
    { value: 'Turkey', label: 'Turkey' },
    { value: 'Turkmenistan', label: 'Turkmenistan' },
    { value: 'Turks And Caicos Islands', label: 'Turks And Caicos Islands' },
    { value: 'Tuvalu', label: 'Tuvalu' },
    { value: 'Uganda', label: 'Uganda' },
    { value: 'United Arab Emirates', label: 'United Arab Emirates' },
    { value: 'United Kingdom', label: 'United Kingdom' },
    { value: 'United States Minor Outlying Islands', label: 'United States Minor Outlying Islands' },
    { value: 'Uzbekistan', label: 'Uzbekistan' },
    { value: 'Vanuatu', label: 'Vanuatu' },
    { value: 'Vatican City State', label: 'Vatican City State' },
    { value: 'Virgin Islands, British', label: 'Virgin Islands, British' },
    { value: 'Virgin Islands, U.S.', label: 'Virgin Islands, U.S.' },
    { value: 'Wallis And Futuna', label: 'Wallis And Futuna' },
    { value: 'Western Sahara', label: 'Western Sahara' },
    { value: 'Zambia', label: 'Zambia' },
    { value: 'Zimbabwe', label: 'Zimbabwe' },
    { value: 'Albania', label: 'Albania' },
    { value: 'American Samoa', label: 'American Samoa' },
    { value: 'Belize', label: 'Belize' },
    { value: 'Bolivia (Plurinational State of)', label: 'Bolivia (Plurinational State of)' },
    { value: 'Brunei Darussalam[f]', label: 'Brunei Darussalam[f]' },
    { value: 'Canada', label: 'Canada' },
    { value: 'Chile', label: 'Chile' },
    { value: 'Costa Rica', label: 'Costa Rica' },
    { value: 'Côte d Ivoire', label: 'Côte d Ivoire' },
    { value: 'Iceland', label: 'Iceland' },
    { value: 'Kazakhstan', label: 'Kazakhstan' },
    { value: 'Korea (the Republic of)', label: 'Korea (the Republic of)' },
    { value: 'Macao', label: 'Macao' },
    { value: 'Niger', label: 'Niger' },
    { value: 'Panama', label: 'Panama' },
    { value: 'Pitcairn', label: 'Pitcairn' },
    { value: 'Poland', label: 'Poland' },
    { value: 'Puerto Rico', label: 'Puerto Rico' },
    { value: 'Saint Barthélemy', label: 'Saint Barthélemy' },
    { value: 'Serbia', label: 'Serbia' },
    { value: 'Sierra Leone', label: 'Sierra Leone' },
    { value: 'Slovakia', label: 'Slovakia' },
    { value: 'Slovenia', label: 'Slovenia' },
    { value: 'Sudan', label: 'Sudan' },
    { value: 'Suriname', label: 'Suriname' },
    { value: 'Tokelau', label: 'Tokelau' },
    { value: 'Ukraine', label: 'Ukraine' },
    { value: 'United States of America', label: 'United States of America' },
    { value: 'UY', label: 'Uruguay' },
    { value: 'VE', label: 'Venezuela' },
    { value: 'VN', label: 'Viet Nam' },
    { value: 'YE', label: 'Yemen' }
  );
  return options;
};
